import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import sharedActions from "../../../../actions/shared-actions"
import {Account} from "../../../pages/Account";
import {withVFTranslation} from "../../../../util/withVFTranslation";
import _ from 'lodash';
import c from "../../../../util/const";
import withVfRouting from "../../../../util/withVFRouting";

class LanguageCtrl extends Component {

  static lookupLanguageDisplay(t, lang){
    let found = null;
    let opts = LanguageCtrl.getLanguageOptions(t);
    _.each(opts, (opt) => {
      if(opt.val === lang){
        found = opt.display;
      }
    })
    return found;
  }

  static getLanguageOptions(t){
    return [
      {
        val : c.language.en_us,
        display : t('English')
      },
      {
        val : c.language.fr_fr,
        display : t('French')
      },
      {
        val : c.language.es_es,
        display : t('Spanish')
      },
      // {
      //   val : 'dev',
      //   display : t('Development')
      // }
    ]
  }

  constructor(props){
    super(props);

    this.state = {
      selectedLanguage : ''
    }
  }

  componentDidMount() {
    if(this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentWillUnmount(){
    if(this.props.onRef) {
      this.props.onRef(undefined);
    }
  }

  changeLanguage(evt){
    this.props.i18n.changeLanguage(evt.target.value, (err, t) => {
      if (err){
        return console.log('something went wrong changing language', err);
      }
      else{
        //No need to update moment locale here, we subscribe to the language
        //change event in i18n.js.
        this.props.setAccountLanguage(this.props.i18n.language)
        this.setState({selectedLanguage : this.props.i18n.language})
      }
    });
  }

  init() {
    this.setState({selectedLanguage : this.props.i18n.language})
  }

  render() {
    let { selectedLanguage} = this.state;
    let { t } = this.props;

    return (
      <div style={Account.styles.rowContents} className={'mt-3 mb-3'}>
        <div className={'row'}>
          <div className={'col'}>

            <div className="form-group">
              <label>{t('Language')}</label>
              <select className="form-select"
                      value={selectedLanguage}
                      onChange={this.changeLanguage.bind(this)}>
                {LanguageCtrl.getLanguageOptions(t).map((option) => {
                  return <option key={option.val}
                                 value={option.val}>
                    {option.display}
                  </option>
                })}
              </select>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

LanguageCtrl.propTypes = {
  doClose : PropTypes.func.isRequired,
  onRef: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {

  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAccountLanguage:(language) => dispatch(sharedActions.setAccountLanguage(language)),
  };
};
export { LanguageCtrl};
export default withVFTranslation()(withVfRouting(connect(mapStateToProps, mapDispatchToProps)(LanguageCtrl)));
